import { SelectList, TextBox } from '@/components/formFields/common';

export const firstName = {
  label: 'First Name',
  componentType: TextBox,
  class: 'col-md-6',
  rules: { required: true, max: 20 }
};

export const lastName = {
  ...firstName,
  label: 'Last Name'
};

export const organization = {
  label: 'Organization',
  componentType: TextBox,
  class: 'col-md-12',
  rules: { max: 40 }
};

export const address1 = {
  label: 'Address Line 1',
  componentType: TextBox,
  class: 'col-md-6',
  rules: { required: true, max: 50 }
};

export const address2 = {
  ...address1,
  label: 'Address Line 2',
  rules: {
    ...address1.rules,
    required: false
  }
};

export const city = {
  label: 'City',
  componentType: TextBox,
  class: 'col-md-6',
  rules: { required: true, max: 30 }
};

export const state = {
  label: 'State',
  componentType: SelectList,
  options: ['AF', 'AK', 'AL', 'AR', 'AS', 'AU', 'AZ', 'CA', 'CE', 'CN', 'CO', 'CT', 'DC', 'DE', 'EU', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'MX', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SA', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'],
  includeEmpty: false,
  class: 'col-md-2',
  rules: { required: true }
};

export const zip = {
  label: 'Zip Code',
  componentType: TextBox,
  class: 'col-md-4',
  rules: {
    max: 10,
    required: true
  }
};

export const email = {
  label: 'E-mail',
  componentType: TextBox,
  class: 'col-md-6',
  rules: {
    email: true,
    max: 49,
    required: true
  }
};

export const phone = {
  label: 'Phone Number',
  componentType: TextBox,
  class: 'col-md-6',
  rules: {
    phone: true,
    required: true
  },
  mask: '(999) 999-9999'
};

export const fax = {
  label: 'Fax Number',
  componentType: TextBox,
  class: 'col-md-6',
  rules: {
    phone: true
  },
  mask: '(999) 999-9999'
};
